import _ from 'lodash';
import { Privilege } from 'ts-types/api.enums';
import { Module } from 'ts-types/api.types';

export interface ModuleDef {
  code: Module;
  path: string;
  privilege?: Privilege;
  enabled: boolean;
}

export const MODULES: ModuleDef[] = [
  {
    code: "MODULE_HOME",
    path: "/",
    // privilege: Privilege.PX_CORE_HOME,
    enabled: true
  },
  {
    code: "MODULE_CDR",
    path: "/clinical-data-record",
    privilege: Privilege.PX_CORE_CLINICAL_DATA_RECORD,
    enabled: true
  },
  {
    code: "MODULE_PATIENT_CENTRAL",
    path: "/patient-central",
    privilege: Privilege.PX_CORE_PATIENT_CENTRAL,
    enabled: true
  },
  {
    code: "MODULE_LAB",
    path: "/lab-central",
    privilege: Privilege.PX_CORE_LAB_CENTRAL,
    enabled: true
  },
  {
    code: "MODULE_TESTING",
    path: "/dashboard",
    privilege: Privilege.PX_CORE_DASHBOARD,
    enabled: true
  },
  {
    code: "MODULE_VACCINATION",
    path: "/dashboard",
    privilege: Privilege.PX_CORE_DASHBOARD,
    enabled: false
  },
  {
    code: "MODULE_GUARANTORS",
    path: "/guarantors",
    privilege: Privilege.PX_CORE_GUARANTORS_CONFIGURATION,
    enabled: true
  },
  {
    code: "MODULE_DOCTORS",
    path: "/doctors",
    privilege: Privilege.PX_CORE_DOCTORS_CONFIGURATION,
    enabled: true
  },
  {
    code: "MODULE_TARIFF",
    path: "/tariff",
    privilege: Privilege.PX_CORE_TARIFFS_CONFIGURATION,
    enabled: true
  },
  {
    code: "MODULE_MEDICINES_MATERIALS",
    path: "/medicaments",
    privilege: Privilege.PX_CORE_MEDICINES_MATERIALS_CONFIGURATION,
    enabled: true
  },
  {
    code: "MODULE_BILLING",
    path: "/billing",
    privilege: Privilege.PX_CORE_BILLS,
    enabled: true
  },
  {
    code: "MODULE_SETTINGS",
    path: "/settings",
    privilege: Privilege.PX_CORE_REFERENCE_DATA_CONFIGURATION,
    enabled: true
  },
  {
    code: "MODULE_USER_SETTINGS",
    path: "/user-settings",
    privilege: Privilege.PX_CORE_USER_SETTINGS_CONFIGURATION,
    enabled: true
  }
]

export const MODULES_MAP: {[key: string] : ModuleDef} = _.keyBy(MODULES, "code");
